import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "./base/header/header.component";
import { AsideComponent } from "./base/aside/aside.component";
import { LayoutComponent } from "./base/layout/layout.component";
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { LoadingBarModule } from '@ngx-loading-bar/core';

import {
  AngularMaterialModule,
  HomesideuiModule,
  LoginuiModule,
  FpassuiModule,
  TwofauiModule,
  MenuinfouiModule,
  HeaderuiModule,
  LogouiModule,
  ChangepwdUiModule,
  TwofaSettingsModule,
  CommunicationUiModule
} from "@school/a2z-lib";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { RouterModule, Routes } from "@angular/router";
// SVG inline
import { InlineSVGModule } from "ng-inline-svg";


@NgModule({
  declarations: [
    HeaderComponent,
    AsideComponent,
    LayoutComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    InlineSVGModule,
    HomesideuiModule,
    LoginuiModule,
    FpassuiModule,
    TwofauiModule,
    MenuinfouiModule,
    HeaderuiModule,
    LogouiModule,
    ChangepwdUiModule,
    TwofaSettingsModule,
    CommunicationUiModule,
    RouterModule,
    PerfectScrollbarModule,
    LoadingBarModule
  ],
  exports: [
    RouterModule
  ],
})
export class ViewsModule {}
